
    module.exports = {
      bytes: 167256,
      height: 157,
      orientation: undefined,
      src: __webpack_public_path__ + "53fd41582edad8791d67f3281285f72c.svg",
      type: "svg",
      width: 150,
    };
    /**
     * For requires from CSS when used with webpack css-loader,
     * outputting an Object doesn't make sense,
     * so overriding the toString method to output just the URL.
     */
    module.exports.toString = function() {
      return __webpack_public_path__ + "53fd41582edad8791d67f3281285f72c.svg";
    };
  